import type { SousDomaine } from '@/models/interfaces/SousDomaine'
import { apiClient } from '@/plugins/axios/api'

function toNumber(value: unknown): number {
  const parsed = Number(value)
  return Number.isFinite(parsed) ? parsed : 0
}

function extractDomaineId(row: Record<string, unknown>): number {
  const relation = row.domaine as Record<string, unknown> | undefined
  const nestedRelation = row.fkDomaine as Record<string, unknown> | undefined
  return toNumber(
    row.fkDomaineId ??
      row.fk_domaine_id ??
      row.domaineId ??
      row.domaine_id ??
      row.fkDomaine ??
      row.fk_domaine ??
      relation?.domaineId ??
      relation?.domaine_id ??
      relation?.id ??
      relation?.['@id'] ??
      nestedRelation?.domaineId ??
      nestedRelation?.domaine_id ??
      nestedRelation?.id ??
      nestedRelation?.['@id'],
  )
}

function normalizeSousDomaine(row: Record<string, unknown>): SousDomaine {
  const id = toNumber(row.sousDomaineId ?? row.sous_domaine_id ?? row.id)
  const domaineId = extractDomaineId(row)
  return {
    '@id': (row['@id'] ?? row.iri ?? `/api/sousdomaines/${id}`) as string,
    sousDomaineId: id,
    fkDomaineId: domaineId,
    sousDomaineCode: String(row.sousDomaineCode ?? row.sous_domaine_code ?? row.code ?? row.sdmCode ?? ''),
    sousDomaineLib: String(
      row.sousDomaineLib ??
        row.sous_domaine_lib ??
        row.nom ??
        row.libelle ??
        row.label ??
        row.sdmLib ??
        row.name ??
        '',
    ),
    // Libellé anglais (nom_en) gardé à part : il servait jusqu'ici de dernier repli du libellé
    // français, ce qui le rendait invisible à la traduction. Voir libelleDynamique.
    sousDomaineLibEn: typeof row.nomEn === 'string' ? row.nomEn : undefined,
  }
}

export class SousDomaineService {
  static async getAll(): Promise<SousDomaine[]> {
    try {
      const response = await apiClient.get('/api/sousdomaines')
      const member = response.data['hydra:member'] ?? []
      if (!Array.isArray(member)) return []
      return member.map((item) => normalizeSousDomaine(item as Record<string, unknown>))
    } catch {
      console.debug('SousDomaine endpoint not available yet, returning empty array.')
      return []
    }
  }
}
